import { Injectable, signal } from '@angular/core';

declare global {
    interface Window {
        Supademo: {
            open: (demoId: string, options?: any) => void;
            widget: {
                open: (demoId: string, options?: any) => void;
            };
        };
    }
}

@Injectable({
    providedIn: 'root'
})
export class SupademoService {
    private loaded = signal(false);
    private scriptElement?: HTMLScriptElement;
    private loadPromise?: Promise<void>;

    private loadScript(): Promise<void> {
        // Éviter les chargements multiples
        if (this.loadPromise) {
            return this.loadPromise;
        }

        // Déjà chargé
        if (window.Supademo) {
            this.loaded.set(true);
            return Promise.resolve();
        }

        // Charger le script
        this.loadPromise = new Promise((resolve, reject) => {
            this.scriptElement = document.createElement('script');
            this.scriptElement.src = 'https://script.supademo.com/supademo.js';
            this.scriptElement.async = true;

            this.scriptElement.onload = () => {
                this.loaded.set(true);
                resolve();
            };

            this.scriptElement.onerror = (error) => {
                console.error('Erreur chargement Supademo:', error);
                this.loaded.set(false);
                reject(error);
            };

            document.head.appendChild(this.scriptElement);
        });

        return this.loadPromise;
    }

    public async openDemo(demoId: string, options?: any): Promise<void> {
        try {
            await this.loadScript();

            if (window.Supademo) {
                window.Supademo.open(demoId, options);
            } else {
                console.warn('Supademo non chargé');
            }
        } catch (error) {
            console.error('Impossible d\'ouvrir la demo Supademo:', error);
        }
    }

    public async openDemoHub(demoHubId: string, options?: any): Promise<void> {
        try {
            await this.loadScript();

            if (window.Supademo) {
                window.Supademo.widget.open(demoHubId, options);
            } else {
                console.warn('Supademo non chargé');
            }
        } catch (error) {
            console.error('Impossible d\'ouvrir la demo Supademo:', error);
        }
    }

    isLoaded(): boolean {
        return this.loaded();
    }

    destroy(): void {
        if (this.scriptElement && this.scriptElement.parentNode) {
            this.scriptElement.parentNode.removeChild(this.scriptElement);
            this.loaded.set(false);
            this.loadPromise = undefined;
        }
    }
}
